import { AdvantageProps } from './model';
import { AdvantageView } from './view';

export const AdvantageCard = (props: AdvantageProps) => {
    return AdvantageView(props);
};
